import type { TTipoDocumento } from '@/shared/interfaces/documentos.enums'
import { HttpService } from '@/shared/lib'
import { StringUtils } from '@/shared/utils'

interface TEnviarDocumentoDaProposta {
  pessoaId: string
  numeroDaProposta: string
  arquivo: File
  tipo: TTipoDocumento
}

export class EnviarDocumentoDaPropostaService extends HttpService {
  execute = async ({ pessoaId, numeroDaProposta, arquivo, tipo }: TEnviarDocumentoDaProposta) => {
    const formData = new FormData()
    formData.append('Arquivo', arquivo)
    formData.append('NomeArquivo', StringUtils.removeAcentos(arquivo.name))
    formData.append('NumeroDaProposta', numeroDaProposta)
    formData.append('CompradorId', pessoaId)
    formData.append('TiposDocumento[]', tipo)
    return this.http.post<
      | { sucesso: true; mensagem: string }
      | { sucesso: false; mensagemDeErro: string; objetoInvalido: boolean; temErro: boolean }
    >('/api/v2/Documentos/proposta', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }
}
